import withStyles from "@material-ui/core/styles/withStyles";

import { confirmAlert } from "react-confirm-alert";

// @material-ui/icons
import Add from "@material-ui/icons/Add";
import AddAlert from "@material-ui/icons/AddAlert";
import Edit from "@material-ui/icons/Edit";
import Delete from "@material-ui/icons/Delete";
import WhereToVote from "@material-ui/icons/WhereToVote";

import { MdLocationCity } from "react-icons/md";

import {
  fetchGetCityDetails,
  fetchGetCities,
  fetchDeleteCity,
  fetchAddCity,
  fetchUpdateCity
} from "actions/city";
import { fetchGetCommunityDetails } from "actions/community";

import { RESET_CITY, SET_DELETE_CITY_CONFIRMATION_NAME } from "actions/types";

// core components
import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import CardHeader from "components/Card/CardHeader";
import CardIcon from "components/Card/CardIcon";
import CardFooter from "components/Card/CardFooter";
import Button from "components/CustomButtons/Button";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Snackbar from "components/Snackbar/Snackbar";
import CustomInput from "components/CustomInput/CustomInput";
import Wizard from "components/DigiHapi/Wizard";

import extendedTablesStyle from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle";
import { beigeColor } from "assets/jss/material-dashboard-pro-react";

// core components
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import ReactTable from "react-table";
import { bindActionCreators } from "redux";
import Components from "./CitiesPage";
import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";

const style = {
  ...extendedTablesStyle,
  customUI: {
    backgroundColor: beigeColor[1],
    maxWidth: "400px",
    borderRadius: "10px",
    padding: 10
  },
  w100: {
    width: "100%"
  },
  floatRight: {
    float: "right"
  },
  justifyContentSpaceAround: {
    display: "flex",
    justifyContent: "space-around"
  },
  descriptionContainer: {
    height: "60px"
  }
};

class CitiesWizard extends React.Component {
  fetchAddCity = () => {
    const {
      fetchAddCity,
      name,
      address,
      zipCode,
      city,
      webSiteUrl,
      mail,
      latitude,
      longitude,
      phone,
      fax,
      registerkey,
      files,
      channelsIds
    } = this.props;

    fetchAddCity({
      name,
      address,
      zipCode,
      city,
      webSiteUrl,
      mail,
      latitude,
      longitude,
      phone,
      fax,
      registerkey,
      files,
      channelsIds
    });
  };

  fetchUpdateCity = () => {
    const {
      fetchUpdateCity,
      _id,
      name,
      registerkey,
      address,
      zipCode,
      city,
      webSiteUrl,
      mail,
      latitude,
      longitude,
      phone,
      fax,
      files,
      logoUri,
      mapUri,
      mapSmallUri,
      equipmentsIds,
      channelsIds
    } = this.props;

    fetchUpdateCity({
      _id,
      name,
      registerkey,
      address,
      zipCode,
      city,
      webSiteUrl,
      mail,
      latitude,
      longitude,
      phone,
      fax,
      files,
      logoUri,
      mapUri,
      mapSmallUri,
      equipmentsIds,
      channelsIds
    });
  };

  render() {
    const { update, isFetching, onClose } = this.props;
    return (
      <GridItem xs={12} sm={12}>
        <Wizard
          onClose={onClose}
          isFetching={isFetching}
          validate
          steps={[
            {
              stepName: "Illustration",
              stepComponent: Step1,
              stepId: "picture"
            },
            {
              stepName: "Informations",
              stepComponent: Step2,
              stepId: "infos"
            },
            {
              stepName: "Localisation",
              stepComponent: Step3,
              stepId: "localisation"
            }
          ]}
          title={update ? "Mise à jour d'une ville" : "Ajout d'une ville"}
          subtitle=""
          finishButtonClick={update ? this.fetchUpdateCity : this.fetchAddCity}
        />
      </GridItem>
    );
  }
}

class CitiesPage extends React.Component {
  state = {
    br: false,
    color: "info",
    message: null,
    wizard: null,
    alert: null,
    name: ""
  };

  componentDidMount() {
    const { cities, fetchGetCities } = this.props;
    if (!cities || Object.entries(cities).length === 0) {
      fetchGetCities();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { snackErrorMsg, snackInfoMsg, newWizard } = this.props;

    if (snackErrorMsg && prevProps.snackErrorMsg !== snackErrorMsg) {
      this.autoCloseMessage();
    }

    if (snackInfoMsg && prevProps.snackInfoMsg !== snackInfoMsg) {
      this.setState({
        wizard: null
      });
      this.props.fetchGetCities();
      this.autoCloseMessage();
    }

    if (newWizard && prevProps.newWizard !== newWizard) {
      this.addWizard(newWizard === "update");
    }
  }

  hideAlert = () => {
    this.setState({
      br: false
    });
  };

  autoCloseMessage = () => {
    const { snackErrorMsg, snackInfoMsg } = this.props;

    this.setState({
      br: true,
      message: snackInfoMsg ? snackInfoMsg : snackErrorMsg,
      color: snackInfoMsg ? "info" : "danger"
    });

    if (snackInfoMsg) {
      setTimeout(this.hideAlert, 5000);
    }
  };

  onClose = () => {
    this.setState({
      wizard: null
    });
    this.props.dispatch({
      type: RESET_CITY
    });
  };

  addWizard = (update = true) => {
    this.setState({
      wizard: <Components.CitiesWizard update={update} onClose={this.onClose} />
    });
  };

  changeCommunity = id => {
    this.props.fetchGetCommunityDetails(id);
  };

  editCity = id => {
    this.props.fetchGetCityDetails(id);
  };

  deleteCity = id => {
    this.props.fetchDeleteCity(id, this.props.deleteConfirmationName);
  };

  getRoundButtons = (id, name) => {
    const { classes } = this.props;
    return [
      { color: "success", icon: WhereToVote, onClick: this.changeCommunity },
      { color: "brown", icon: Edit, onClick: this.editCity },
      { color: "danger", icon: Delete, onClick: this.delete }
    ].map((prop, key) => {
      return (
        <Button
          round
          color={prop.color}
          className={classes.actionButton + " " + classes.actionButtonRound}
          key={key}
          disabled={this.state && this.state.wizard ? true : false}
          onClick={() => prop.onClick(id, name)}
        >
          <prop.icon className={classes.icon} />
        </Button>
      );
    });
  };

  getCities = () => {
    const { cities } = this.props;

    const citiesObj = Object.values(cities).map(({ _id, name }) => {
      return {
        name,
        actions: (
          <div className="actions-right">{this.getRoundButtons(_id, name)}</div>
        )
      };
    });
    return citiesObj;
  };

  delete = (cityId, cityName) => {
    const { classes, dispatch } = this.props;
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className={classes.customUI}>
            <h2>Confirmation</h2>
            <p>Êtes-vous sûr de vouloir supprimer la ville ?</p>
            {`Confirmer la suppression de la ville en saisisant le nom de la ville ${cityName}`}
            <CustomInput
              labelText="Ville ..."
              id="city"
              formControlProps={{
                fullWidth: true
              }}
              inputProps={{
                // value: deleteConfirmationName,
                onChange: e =>
                  dispatch({
                    type: SET_DELETE_CITY_CONFIRMATION_NAME,
                    value: e.target.value
                  })
              }}
            />
            <div className={classes.justifyContentSpaceAround}>
              <Button
                onClick={() => {
                  onClose();
                }}
              >
                Annuler
              </Button>
              <Button
                color="danger"
                onClick={() => {
                  this.deleteCity(cityId);
                  onClose();
                }}
              >
                Supprimer
              </Button>
            </div>
          </div>
        );
      }
    });
  };

  render() {
    const { color, message, alert } = this.state;
    const { classes, isFetchingList } = this.props;

    return (
      <GridContainer justify="center">
        {alert}
        <GridItem xs={12}>
          <Card>
            <CardHeader icon>
              <CardIcon color="primary">
                <MdLocationCity />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>Villes</h4>
            </CardHeader>
            <CardBody>
              <ReactTable
                data={this.getCities()}
                filterable
                columns={[
                  {
                    Header: "Nom",
                    accessor: "name",
                    sortable: true,
                    filterable: false
                  },
                  {
                    Header: "Actions",
                    accessor: "actions",
                    sortable: false,
                    filterable: false
                  }
                ]}
                loading={isFetchingList}
                defaultPageSize={5}
                showPaginationTop
                showPaginationBottom={false}
                previousText="Précédent"
                nextText="Suivant"
                rowsText="Lignes"
                noDataText="Aucunes villes"
                ofText="sur"
                loadingText="Chargement..."
                className="-striped -highlight"
              />
            </CardBody>
            <CardFooter product>
              <div className={classes.w100}>
                <Button
                  className={classes.floatRight}
                  color="primary"
                  onClick={() => this.addWizard(false)}
                  disabled={this.state.wizard}
                >
                  <Add /> {"Ajout d'une ville"}
                </Button>
              </div>
            </CardFooter>
          </Card>
        </GridItem>
        {this.state.wizard}
        <Snackbar
          place="br"
          color={color}
          icon={AddAlert}
          message={message ? message : ""}
          open={this.state.br}
          closeNotification={() => this.setState({ br: false })}
          close
        />
      </GridContainer>
    );
  }
}

CitiesPage.propTypes = {
  classes: PropTypes.object
};

const mapStateToProps = state => {
  const {
    _id,
    isFetching,
    isFetchingList,
    name,
    address,
    zipCode,
    city,
    webSiteUrl,
    mail,
    latitude,
    longitude,
    phone,
    fax,
    registerkey,
    files,
    snackInfoMsg,
    snackErrorMsg,
    logoUri,
    mapUri,
    mapSmallUri,
    newWizard,
    equipmentsIds,
    deleteConfirmationName,
    channelsIds
  } = state.cityReducer;

  const { cities } = state.entitiesReducer;
  return {
    _id,
    isFetching,
    isFetchingList,
    name,
    address,
    zipCode,
    city,
    webSiteUrl,
    mail,
    latitude,
    longitude,
    phone,
    fax,
    registerkey,
    files,
    cities,
    snackInfoMsg,
    snackErrorMsg,
    logoUri,
    mapUri,
    mapSmallUri,
    newWizard,
    equipmentsIds,
    deleteConfirmationName,
    channelsIds
  };
};

const mapDispatchToProps = dispatch => {
  let actions = bindActionCreators(
    {
      fetchGetCities,
      fetchGetCityDetails,
      fetchDeleteCity,
      fetchAddCity,
      fetchUpdateCity,
      fetchGetCommunityDetails
    },
    dispatch
  );
  return { ...actions, dispatch };
};

export default {
  CitiesPage: connect(
    mapStateToProps,
    mapDispatchToProps
  )(withStyles(style)(CitiesPage)),
  CitiesWizard: connect(
    mapStateToProps,
    mapDispatchToProps
  )(withStyles(style)(CitiesWizard))
};
